<app-modal-template
	[iconId]="240"
	[title]="title"
	[showSave]="showSave"
	[disableSave]="!formGroup.valid"
	[saveText]="'Save'"
	[saveIcon]="['fass', 'check-circle']"
	[showCancel]="showCancel"
	[cancelText]="'Cancel'"
	[cancelIcon]="['fass', 'arrow-circle-left']"
	[showX]="true"
	(cancelClicked)="cancelClick()"
	(saveClicked)="saveClick()"
>
	<form [formGroup]="formGroup">
		<app-spinner *ngIf="loading"></app-spinner>
		<div *ngIf="!loading">
			<mat-card appearance="outlined">
				<mat-form-field class="full-width">
					<mat-label>Batch Label</mat-label>
					<input matInput type="text" formControlName="labelText" />
				</mat-form-field>
				<mat-form-field class="full-width">
					<mat-label>Compliance Date</mat-label>
					<input
						matInput
						[min]="today"
						[matDatepicker]="complianceDatePicker"
						formControlName="complianceDate"
						(dateChange)="complianceDateChanged()"
						autocomplete="off"
					/>
					<mat-datepicker-toggle matSuffix [for]="complianceDatePicker"></mat-datepicker-toggle>
					<mat-datepicker #complianceDatePicker></mat-datepicker>
				</mat-form-field>
				<mat-form-field class="full-width">
					<mat-label>Compliance Date Change Reason</mat-label>
					<mat-select formControlName="complianceDateChangeReason">
						<mat-option
							*ngFor="let r of complianceDateChangeReasons"
							[value]="r.complianceDateChangeReasonId"
						>
							{{ r.description }}
						</mat-option>
					</mat-select>
					<!--<mat-error [appFormError]="formGroup.get('complianceDateChangeReason').errors"></mat-error>-->
					<mat-error *ngIf="formGroup.get('complianceDateChangeReason')?.errors?.required"
						>Change Reason is required</mat-error
					>
				</mat-form-field>
			</mat-card>
			<mat-card appearance="outlined" class="log-entry" *ngFor="let entry of batchHistory; let i = index">
				<div class="change-timestamp">
					<div *ngIf="entry?.displayName">
						<b>{{ entry?.displayName }}</b> changed <b>{{ entry?.fieldName }}</b> to
						<span *ngIf="entry.fieldName == 'Compliance Date'">
							{{ entry?.field | moment: 'MM/DD/YYYY' }}
						</span>
						<span *ngIf="entry.fieldName != 'Compliance Date'">
							{{ entry?.field }}
						</span>
						on {{ entry?.validFrom | moment: 'MM/DD/YYYY' }}
					</div>
					<div *ngIf="!entry?.displayName">
						<b>System</b> set <b>{{ entry?.fieldName }}</b> on
						{{ entry?.validFrom | moment: 'MM/DD/YYYY hh:mm A' }}
					</div>
				</div>

				<!--<div *ngIf="entry.previousValue && entry.fieldName == 'Compliance Date'">
			<h3>Previous Value</h3>
			{{ entry?.previousValue | moment: 'MM/DD/YYYY' }}
		</div>-->
				<!--<div *ngIf="entry.previousValue && entry.fieldName != 'Compliance Date'">
			<h3>Previous Value</h3>
			{{ entry?.previousValue }}
		</div>-->
				<!--<div *ngIf="entry.fieldName == 'Compliance Date'">
			<h3>Value</h3>
			{{ entry?.field | moment: 'MM/DD/YYYY' }}
		</div>-->
				<!--<div *ngIf="entry.fieldName != 'Compliance Date'">
			<h3>Value</h3>
			{{ entry?.field }}
		</div>-->
			</mat-card>
		</div>
	</form>
</app-modal-template>
